import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import components from "./components/index";
import JsonViewer from "vue-json-viewer";
import dayjs from "dayjs";

// 导入清理函数
import { clearAllAuth, isLoginPage } from "@/utils/auth";

// ============ 关键修复：在应用启动前清理 ============
console.log('🚀 应用启动，当前路径:', window.location.pathname);

// 如果当前在登录页或访问根路径，清理旧的认证信息
if (isLoginPage() || window.location.pathname === '/') {
  console.log('🧹 清理旧的认证信息');
  clearAllAuth();
  
  // 确保路由状态重置
  store.commit('user/RESET_USER');
  store.commit('user/SET_ROUTES_LOADED', false);
  
  // 强制刷新路由
  const currentPath = window.location.pathname;
  if (currentPath === '/') {
    console.log('📍 访问根路径，重定向到登录页');
    window.location.href = '/login';
  }
}

// 统一只在这里导入 ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 全局配置（必须在 Vue.use() 之前配置）
Vue.use(ElementUI, {
  size: 'small', // 全局设置组件默认尺寸
  zIndex: 3000  // 可选：设置初始 zIndex
})

import SessionStorage from "./plugins/sessionStorage";
// 用法 v-dompurify-html
import VueDOMPurifyHTML from "vue-dompurify-html";

// 导入 dayjs 插件（仅添加中文支持和相对时间）
import 'dayjs/locale/zh-cn'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.locale('zh-cn')
dayjs.extend(relativeTime)

// 全局时间格式化过滤器 - 简化版
Vue.filter("formatDate", (value, format = "YYYY.MM.DD HH:mm:ss") => {
  if (!value) return "";
  return dayjs(value).format(format);
});

// 相对时间过滤器
Vue.filter("relativeTime", (value) => {
  if (!value) return "从未";
  return dayjs(value).fromNow();
});

// 天数差过滤器
Vue.filter("daysAgo", (value) => {
  if (!value) return "∞";
  const now = dayjs();
  const target = dayjs(value);
  const days = now.diff(target, 'day');
  return days;
});

Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV === "development";
Vue.use(components);
Vue.use(JsonViewer);
Vue.use(VueDOMPurifyHTML);
Vue.use(SessionStorage);

// button节流，在button中添加 v-preventReClick 即可控制按钮，防止按钮连击，时间限制2s
Vue.directive("preventReClick", {
  inserted(el) {
    el.addEventListener("click", () => {
      if (el.style.pointerEvents !== "none") {
        el.style.pointerEvents = "none";
        setTimeout(() => {
          el.style.pointerEvents = "";
        }, 2000);
      }
    });
  },
});

// 只允许数据数字，使用时直接添加v-number-only即可
Vue.directive("number-only", {
  bind(el) {
    const input = el.querySelector("input") || el;
    input.addEventListener("input", () => {
      const newValue = input.value.replace(/[^\d]/g, "");
      if (input.value !== newValue) {
        input.value = newValue;
        // 触发v-model更新
        input.dispatchEvent(new Event("input"));
      }
    });
  },
});

// 全局错误处理
Vue.config.errorHandler = (err, vm, info) => {
  console.error('Vue 错误:', err, info);
  
  // 如果是认证错误，重定向到登录页
  if (err.message && (err.message.includes('401') || err.message.includes('认证') || err.message.includes('token'))) {
    console.log('检测到认证错误，清理并跳转');
    clearAllAuth();
    store.commit('user/RESET_USER');
    setTimeout(() => {
      window.location.href = '/login';
    }, 100);
  }
};

// 全局未处理的Promise rejection处理
window.addEventListener('unhandledrejection', (event) => {
  console.error('未处理的Promise rejection:', event.reason);
  event.preventDefault(); // 阻止默认的浏览器错误提示
  
  // 如果是401错误，清理并跳转
  if (event.reason && 
      (event.reason.status === 401 || 
       event.reason.message?.includes('401') || 
       event.reason.message?.includes('认证'))) {
    console.log('检测到认证Promise错误，清理并跳转');
    clearAllAuth();
    store.commit('user/RESET_USER');
    setTimeout(() => {
      window.location.href = '/login';
    }, 100);
  }
});

// 创建Vue实例
new Vue({
  router,
  store,
  render: (h) => {
    return h(App);
  },
  created() {
    console.log('🎉 Vue实例创建完成');
    
    // 检查初始状态
    const token = sessionStorage.getItem('access-token');
    console.log('初始Token状态:', token ? '存在' : '不存在');
  }
}).$mount("#app");